import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: theme.colors.black,
  },
  container: {
    flex: 1,
    backgroundColor: theme.colors.lightBlue,
  },
});
